<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
             :close-on-press-escape="false" :append-to-body="true">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-row>
        <el-col :span="18">
          <el-form-item label="联系人：" prop="contactMan">
            <el-input v-model="dataForm.contactMan" placeholder="联系人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="" prop="isDefault" label-width="20px">
            <el-checkbox v-model="dataForm.isDefault" :true-label="1" :false-label="0">默认联系人</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="联系电话：" prop="contactPhone">
        <el-input v-model="dataForm.contactPhone" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="地址：" prop="contactAddress">
        <el-input v-model="dataForm.contactAddress" placeholder="地址"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="6" placeholder=""></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props:{
    companyId:''
  },
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {
        id: '',
        companyId: '',
        contactMan: '',
        contactPhone: '',
        contactAddress: '',
        isDefault: 0,
        remark: '',
      }
    }
  },
  computed: {
    dataRule () {
      return {
        contactMan: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], contactPhone: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    reset () {
      this.dataForm = {
        companyId: '', contactMan: '', contactPhone: '', contactAddress: '', isDefault: '', remark: '',
      }
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields()
      }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/trade/company/contact/${this.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm,
          companyId:this.companyId
        }
        this.$http[!postForm.id ? 'post' : 'put']('/trade/company/contact/', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel () {
      this.visible = false
    }
  }
}
</script>
